import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type EarningsActiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function EarningsActiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: EarningsActiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M24.93 8.725a3.174 3.174 0 00-2.263-.933h-3.792V6.333a3.208 3.208 0 00-3.208-3.208h-2.334a3.185 3.185 0 00-3.208 3.208v3.792H6.333a3.186 3.186 0 00-3.208 3.208v9.334a3.209 3.209 0 003.208 3.208h16.334a3.231 3.231 0 003.208-3.208V11a3.195 3.195 0 00-.945-2.275zm-7.805 15.4h-5.25V6.298a1.435 1.435 0 011.458-1.458h2.334c.383.002.752.152 1.026.42.272.278.427.65.432 1.038v17.827z"
        className={pathClassName}
      />
    </Svg>
  );
}

export default EarningsActiveIcon;
